'use strict';

const { hasClass } = require('../domUtil');
const { KBD_CLASS } = require('../constants');

// sticky header reserved height
const RESERVED_HEADER_SPACE = 82; // px

function initFocusScrollFix() {
    document.addEventListener('focusin', event => {

        if (!hasClass(document.body, KBD_CLASS)) return;

        const el = event.target;

        if (!(el instanceof HTMLElement)) return;

        const hasScrollMarginTop = window.getComputedStyle(el).scrollMarginTop !== '0px';
        if (hasScrollMarginTop) return;

        if (
            el.closest('.modal') ||
            hasClass(el, 'close-current-modal') ||
            el.closest('.page-top-navigation')
        ) return;

        const rect = el.getBoundingClientRect();

        if (rect.top < RESERVED_HEADER_SPACE) {
            const delta = RESERVED_HEADER_SPACE - rect.top;

            window.scrollBy({
                top: -delta,
                behavior: 'smooth'
            });
        }
    });
}

module.exports.initFocusScrollFix = initFocusScrollFix;
